var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 155",
    d: "M1.41016 15V20.25C1.41016 20.25 1.41016 21 2.05187 21.75C2.69358 22.5 3.33529 22.5 3.33529 22.5C3.33529 22.5 17.4529 22.5 20.0198 22.5C22.5866 22.5 22.5866 20.25 22.5866 20.25V15",
    stroke: "#323232",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 156",
    d: "M12.0002 16.5L12.0002 1.5M12.0002 1.5L7.05905 5.25M12.0002 1.5L16.9414 5.25",
    stroke: "#323232",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/importIcon.8f808bb5a8e9eee99b40b19820c886e7.svg";
export { ForwardRef as ReactComponent };